import NoAuthorizedImage from '@assets/NoAuthorized.svg';
import ScreenMessage from './ScreenMessage';

const NoAuthorized: React.FC = () => (
	<div style={{ height: '100vh' }}>
		<ScreenMessage
			fullHeight
			fullWidth
			alt="Persona mirando el computador portátil"
			description={
				<>
					No tienes permisos para acceder a este sitio
					<br />
					Por favor, consulta con el administrador del sistema
				</>
			}
			id="no-authorized"
			image={NoAuthorizedImage}
			title="Lo sentimos"
		/>
	</div>
);

export default NoAuthorized;
